/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { CoreAppStore } from '@opengeoweb/store';
import { layerActions, layerSelectors } from '@opengeoweb/store';
import SelectableFeaturesCheckbox from './SelectableFeaturesCheckbox';

interface SelectableFeaturesCheckboxConnectProps {
  layerId: string;
  disabled?: boolean;
}

const SelectableFeaturesCheckboxConnect: React.FC<
  SelectableFeaturesCheckboxConnectProps
> = ({ layerId, disabled }: SelectableFeaturesCheckboxConnectProps) => {
  const dispatch = useDispatch();

  const isSelectable = useSelector((store: CoreAppStore) =>
    layerSelectors.getIsLayerSelectable(store, layerId),
  );

  const toggleSelectable = React.useCallback(
    () =>
      dispatch(
        layerActions.toggleSelectableFeatures({
          layerId,
        }),
      ),
    [dispatch, layerId],
  );

  return (
    <SelectableFeaturesCheckbox
      disabled={disabled}
      isSelectable={isSelectable}
      layerId={layerId}
      onToggleSelectable={toggleSelectable}
    />
  );
};

export default SelectableFeaturesCheckboxConnect;
